/**
 * Static config for the Add/Edit Vehicle modal.
 * @module vehicleModal/constants
 */

/**
 * NHTSA vPIC public VIN decoder. CORS-enabled, no auth, free.
 * See BACKEND_GAPS.md for the production `getVehicleDetailsByVin` query that
 * should eventually replace this direct client-side call.
 */
export const NHTSA_DECODE_VIN_URL = "https://vpic.nhtsa.dot.gov/api/vehicles/decodevin";

/** A complete VIN is always 17 characters. */
export const VIN_LENGTH = 17;

/** Earliest plausible model year for validation. */
export const MIN_VEHICLE_YEAR = 1900;

/** The four opportunity vehicle types shown in the "+ Add Vehicle" dropdown. */
export const CUSTOMER_INTERESTS = ["BUY", "SELL", "TRADE", "SERVICE"];

/** Condition options for a Sell/Trade/Service vehicle (quality grade). */
export const VEHICLE_CONDITION_OPTIONS = ["Excellent", "Very Good", "Good", "Fair", "Poor"];

/**
 * Customer-interest types describing a vehicle the customer already owns, so
 * there is no Inventory picker step (the tab bar is dropped and the request
 * form is shown on its own).
 */
export const SELL_SIDE_INTERESTS = ["SELL", "TRADE", "SERVICE"];

/**
 * Customer-interest types whose Customer Preferences show the trade-in
 * appraisal fields (Odometer, Title Type, Condition, Expected Price, Payoff
 * Amount, Mileage) instead of the buyer's Price/Mileage Range.
 *
 * SERVICE is deliberately NOT in this list: a service vehicle is not being
 * appraised, so it has its own field set (Odometer, Plate, Unit Number,
 * Factory/Extended Warranty) — see CustomerPreferencesSection.
 */
export const TRADE_SIDE_INTERESTS = ["SELL", "TRADE"];

/** Default page size for the Inventory tab table. */
export const INVENTORY_PAGE_SIZE = 10;

/** Body style options for manual entry (matches the legacy wishlist form). */
export const BODY_STYLE_OPTIONS = [
  "Sedan",
  "SUV",
  "Truck",
  "Coupe",
  "Convertible",
  "Wagon",
  "Van",
  "Hatchback",
];

/** Vehicle Request tab key vs Inventory tab key. */
export const TAB_KEYS = {
  INVENTORY: "inventory",
  REQUEST: "request",
};
